export default __webpack_public_path__ + "static/banner-ai-tool-1b3c2af2a28524b2dfa5cb186e346f34.png";